if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      this.addAllButton = this.querySelector('[data-look-add-all]');
      this.errorElement = this.querySelector('[data-look-error]');
      this.addAllButton?.addEventListener('click', this.addAll.bind(this));
    }

    getItems() {
      return [...this.querySelectorAll('[data-look-product]')].reduce((items, card) => {
        const form = card.querySelector('.product-card-quick-buy__form');
        const formButton = form?.querySelector('[name="add"]');
        const variantInput = form?.querySelector('[name="id"]');
        const variantId = variantInput?.value || card.dataset.fallbackVariantId;
        const fallbackAvailable = card.dataset.fallbackVariantAvailable === 'true';
        const available = formButton ? !formButton.disabled && formButton.getAttribute('aria-disabled') !== 'true' : fallbackAvailable;

        if (variantId && available) items.push({ id: Number(variantId), quantity: 1 });
        return items;
      }, []);
    }

    setError(message = '') {
      if (!this.errorElement) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = !message;
    }

    async addAll() {
      const items = this.getItems();
      if (!items.length || !this.addAllButton) return;

      const button = this.addAllButton;
      const sectionsToUpdate = ['page-header', 'cart-drawer']
        .map((selector) => document.querySelector(selector))
        .filter((element) => element);
      const sectionIds = sectionsToUpdate.map((element) => element.dataset.sectionId);

      this.setError();
      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'The full look could not be added.');
        }

        if (data.sections && sectionsToUpdate.length) {
          sectionsToUpdate.forEach((element) => {
            const sectionHtml = data.sections[element.dataset.sectionId];
            if (sectionHtml) element.updateFromCartChange(sectionHtml);
          });
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        button.textContent = button.dataset.successLabel;
        this.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantIds: items.map((item) => item.id) }
        }));

        if (theme.settings.afterAddToCart === 'drawer') {
          document.querySelector('.js-cart-drawer')?.open(button);
        } else if (theme.settings.afterAddToCart === 'page') {
          window.location.href = theme.routes.cart;
        }
      } catch (error) {
        this.setError(error.message);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: error.message }
        }));
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
        window.setTimeout(() => {
          button.textContent = button.dataset.defaultLabel;
        }, 2000);
      }
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}
